<template>
  <div>
    <div class="row">
      <div class="col col-md-12 col-sm-12 text-center">
        <div
          class="d-flex justify-content-center"
          v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }"
        >
          <div class="btn-group" role="group" style="margin-left: 10px">
            <button
              type="button"
              @click="novo()"
              class="btn btn-sm btn-light"
              aria-expanded="false"
            >
              <small>Novo<br /></small>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-bar-chart-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"
                />
              </svg>
            </button>
          </div>

          <div class="btn-group" role="group" style="margin-left: 10px">
            <button
              type="button"
              @click="carregarItens()"
              class="btn btn-sm btn-light"
              aria-expanded="false"
            >
              <small>Atualizar<br /></small>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-arrow-clockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                />
                <path
                  d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
                />
              </svg>
            </button>
          </div>

          <div class="btn-group" role="group" style="margin-left: 10px">
            <button
              type="button"
              @click="abrirDialogComissoes()"
              class="btn btn-sm btn-light"
              aria-expanded="false"
            >
              <small>Histórico<br /></small>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-clock-history"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"
                />
                <path
                  d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"
                />
                <path
                  d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"
                />
              </svg>
            </button>
          </div>
        </div>

        <hr
          v-bind:style="{ display: propView == 'completo' ? 'block' : 'none' }"
        />

        <div class="row" v-if="retornaSite() == '7live'">
          <div class="col col-1"></div>
          <div class="col col-10">
            <div class="d-flex justify-content-between" style="">
              <h6 style="padding-top: 8px; margin-top: 0px">
                <small
                  >Total:
                  <span class="text-secondary"
                    >€
                    {{
                      formatCurrency(
                        this.totalEventosPlanoValor +
                          this.totalEventosAvulsoValor
                      )
                    }}</span
                  >
                  Planos:
                  <span class="text-secondary"
                    >€ {{ formatCurrency(this.totalEventosPlanoValor) }} ({{
                      itens.length
                    }})</span
                  >
                  Avulso:
                  <span class="text-secondary"
                    >€ {{ formatCurrency(this.totalEventosAvulsoValor) }} ({{
                      this.totalEventosAvulso
                    }})</span
                  >
                  <span v-if="this.comissaoSelecionada !== null">
                    <span> Comissão: </span>
                    <span class="text-secondary"
                      >{{ this.porcentagemComissao }} %</span
                    >
                    <span> Data: </span>
                  </span>
                </small>
              </h6>
              <div style="margin-bottom: 10px">
                <span class="dropdown" style="margin-right: 5px" v-if="false">
                  <button
                    v-if="comissaoSelecionada == null"
                    class="btn btn-sm btn-outline-secondary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {{ this.porcentagemComissao }} %
                  </button>
                  <div class="dropdown-menu">
                    <span
                      class="dropdown-item"
                      @click="porcentagemComissao = 50"
                      >50 %</span
                    >
                    <span
                      class="dropdown-item"
                      @click="porcentagemComissao = 55"
                      >55 %</span
                    >
                    <span
                      class="dropdown-item"
                      @click="porcentagemComissao = 60"
                      >60 %</span
                    >
                    <span
                      class="dropdown-item"
                      @click="porcentagemComissao = 65"
                      >65 %</span
                    >
                    <span
                      class="dropdown-item"
                      @click="porcentagemComissao = 70"
                      >70 %</span
                    >
                  </div>
                </span>
                <button
                  v-if="comissaoSelecionada == null"
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  @click="processarComissao()"
                >
                  Processar Comissão
                </button>
              </div>
            </div>

            <div
              class="card"
              style="margin-bottom: 10px"
              v-for="itemUsuario in itensUsuario"
              :key="itemUsuario.usuario"
              :item="itemUsuario"
            >
              <div class="card-body text-left">
                <h5 class="card-title" style="margin-bottom: 0px">
                  <small v-if="itensUsuariosDados[itemUsuario.usuario]">{{
                    itensUsuariosDados[itemUsuario.usuario].nome
                  }}</small>
                </h5>
                <div class="row">
                  <div class="col col-4">
                    <p
                      class="card-text"
                      style="padding: 0; margin: 0; margin-bottom: 5px"
                    >
                      <small
                        >Comissão €
                        {{ formatCurrency(itemUsuario.comissao) }} de €
                        {{ formatCurrency(totalComissao) }}</small
                      >
                    </p>
                    <div class="progress">
                      <div
                        class="progress-bar bg-warning"
                        role="progressbar"
                        v-bind:style="{
                          width:
                            (
                              (100 * itemUsuario.comissao) /
                              totalComissao
                            ).toString() + '%',
                        }"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                  <div class="col col-4">
                    <p
                      class="card-text"
                      style="padding: 0; margin: 0; margin-bottom: 5px"
                    >
                      <small
                        >Visualizações
                        {{ formatDouble(itemUsuario.eventosPlano) }} de
                        {{ formatDouble(totalEventosPlano) }}</small
                      >
                    </p>
                    <div class="progress">
                      <div
                        class="progress-bar bg-success"
                        role="progressbar"
                        v-bind:style="{
                          width:
                            (
                              (100 * itemUsuario.eventosPlano) /
                              totalEventosPlano
                            ).toString() + '%',
                        }"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                  <div class="col col-4">
                    <p
                      class="card-text"
                      style="padding: 0; margin: 0; margin-bottom: 5px"
                    >
                      <small
                        >Avulso {{ formatDouble(itemUsuario.eventosAvulso) }} de
                        {{ formatDouble(totalEventosAvulso) }}</small
                      >
                    </p>
                    <div class="progress">
                      <div
                        class="progress-bar bg-success"
                        role="progressbar"
                        v-bind:style="{
                          width:
                            (
                              (100 * itemUsuario.eventosAvulso) /
                              totalEventosAvulso
                            ).toString() + '%',
                        }"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="d-flex justify-content-center"
          role="group"
          aria-label="Basic example"
          style="margin-bottom: 10px"
        >
          <button
            type="button"
            style="margin-right: 5px"
            class="btn btn-sm"
            v-bind:class="{
              'btn-primary': abaSelecionada == 'planos',
              'btn-outline-primary': abaSelecionada !== 'planos',
            }"
            @click="trocarAba('planos')"
          >
            Planos
          </button>
          <button
            type="button"
            style="margin-right: 5px"
            class="btn btn-sm"
            v-bind:class="{
              'btn-primary': abaSelecionada == 'avulso',
              'btn-outline-primary': abaSelecionada !== 'avulso',
            }"
            @click="trocarAba('avulso')"
          >
            Avulso
          </button>
        </div>

        <div class="row" v-if="abaSelecionada == 'planos'">
          <div class="col col-1"></div>
          <div class="col col-10">
            <div
              class="list-group-item"
              v-for="item in itens"
              :key="item.key"
              :item="item"
            >
              <div class="row">
                <div class="col col-md-12">
                  <div class="d-flex w-100 justify-content-between">
                    <div class="d-flex justify-content-start">
                      <button
                        @click="excluir(item)"
                        v-if="item.status == 'Agendado'"
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        style="zoom: 0.6; max-height: 28px; margin-right: 10px"
                      >
                        X
                      </button>
                      <h6
                        class="mb-1"
                        v-bind:style="{
                          display: propView == 'usuario' ? 'block' : 'none',
                        }"
                      >
                        {{ item.plano.nome }}
                        <small
                          class="text-secondary"
                          v-bind:style="{
                            display:
                              retornaSite() == '7live' && propView == 'usuario'
                                ? ''
                                : 'none',
                          }"
                        >
                          (€ {{ item.plano.valor }})</small
                        >
                      </h6>
                      <h6
                        class="mb-1"
                        v-bind:style="{
                          display: propView == 'completo' ? 'block' : 'none',
                        }"
                      >
                        {{ item.usuario.email }}
                      </h6>
                      <h6
                        class="mb-1 text-secondary"
                        style="margin-left: 6px"
                        v-if="propView == 'completo' && item.indicacao !== null"
                      >
                        <small>/ {{ item.indicacao.email }}</small>
                      </h6>
                    </div>
                    <h6>
                      <small v-if="item.diasRestantes == 0"
                        ><b>Finalizou hoje</b></small
                      >
                      <small v-if="item.diasRestantes > 0"
                        ><b
                          >Finalizou a {{ item.diasRestantes }} dia(s)</b
                        ></small
                      >
                    </h6>
                  </div>
                  <div>
                    <p
                      class="text-secondary textoResumo d-flex w-100 justify-content-between"
                    >
                      <small
                        >Lançamento: {{ formatDateTime(item.dataLancamento) }}
                        <span
                          v-bind:style="{
                            display: propView == 'completo' ? '' : 'none',
                          }"
                        >
                        </span
                      ></small>
                      <small
                        >Período: {{ formatDate(item.dataInicio) }} -
                        {{ formatDate(item.dataFim) }} ({{
                          item.duracao
                        }}
                        dias)</small
                      >
                    </p>
                    <p
                      class="text-secondary textoResumo d-flex w-100 justify-content-between"
                    >
                      <small
                        ><span>Plano: {{ item.plano.nome }}</span
                        ><span v-if="retornaSite() == '7live'">
                          (€ {{ item.plano.valor }})</span
                        ></small
                      >
                    </p>
                  </div>

                  <div>
                    <p
                      class="text-secondary textoResumo d-flex w-100 justify-content-between"
                    >
                      <small
                        ><span
                          >Eventos: {{ item.finalizado.eventos }} x €
                          {{
                            formatCurrencyNoLimit(item.finalizado.valorUnitario)
                          }}</span
                        ></small
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="abaSelecionada == 'avulso'">
          <div class="col col-1"></div>
          <div class="col col-10">
            <div
              class="list-group-item"
              v-for="itemEventoAvulso in itensEventosAvulso"
              :key="itemEventoAvulso.key"
              :item="itemEventoAvulso"
            >
              <div class="row">
                <div class="col col-md-12">
                  <div class="d-flex w-100 justify-content-between">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex justify-content-start">
                        <h6
                          class="mb-1"
                          v-bind:style="{
                            display: propView == 'usuario' ? 'block' : 'none',
                            'text-decoration':
                              itemEventoAvulso.excluir == true
                                ? 'line-through'
                                : 'none',
                          }"
                        >
                          <small></small>{{ itemEventoAvulso.evento.nome }}
                        </h6>
                        <h6
                          class="mb-1"
                          v-bind:style="{
                            display: propView == 'completo' ? 'block' : 'none',
                            'text-decoration':
                              itemEventoAvulso.excluir == true
                                ? 'line-through'
                                : 'none',
                          }"
                        >
                          {{ itemEventoAvulso.usuario.email }}
                        </h6>
                      </div>
                    </div>
                    <div>
                      <h6
                        class="mb-1"
                        v-bind:style="{
                          display: propView == 'completo' ? 'block' : 'none',
                          'text-decoration':
                            itemEventoAvulso.excluir == true
                              ? 'line-through'
                              : 'none',
                        }"
                      >
                        € {{ itemEventoAvulso.valor }}
                      </h6>
                      <h6
                        class="mb-1"
                        v-bind:style="{
                          display: propView == 'usuario' ? 'block' : 'none',
                          'text-decoration':
                            itemEventoAvulso.excluir == true
                              ? 'line-through'
                              : 'none',
                        }"
                      >
                        <small></small>€ {{ itemEventoAvulso.valor }}
                      </h6>
                    </div>
                  </div>
                  <div>
                    <p
                      class="text-secondary textoResumo d-flex w-100 justify-content-between"
                    >
                      <small
                        v-bind:style="{
                          display: propView == 'usuario' ? 'block' : 'none',
                        }"
                        >Data: {{ itemEventoAvulso.evento.dataDia }}/{{
                          itemEventoAvulso.evento.dataMes
                        }}/{{ itemEventoAvulso.evento.dataAno }}
                        {{ itemEventoAvulso.evento.dataHora }}:{{
                          itemEventoAvulso.evento.dataMinuto
                        }}</small
                      >
                      <small
                        v-bind:style="{
                          display: propView == 'completo' ? 'block' : 'none',
                        }"
                        >Evento: {{ itemEventoAvulso.evento.dataDia }}/{{
                          itemEventoAvulso.evento.dataMes
                        }}/{{ itemEventoAvulso.evento.dataAno }}
                        {{ itemEventoAvulso.evento.dataHora }}:{{
                          itemEventoAvulso.evento.dataMinuto
                        }}
                        - {{ itemEventoAvulso.evento.nome }}</small
                      >
                      <small style="margin-right: 3px"
                        >Lançamento:
                        {{
                          formatDateTime(itemEventoAvulso.dataLancamento)
                        }}</small
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      :id="'dialogComissoes'"
      titulo="Comissões"
      ref="dialogComissoes"
      :modal="true"
      :hideFooter="true"
    >
      <ListComissoes ref="listComissoes" @selecionar="selecionarComissao" />
    </Dialog>
  </div>
</template>

<script>
import { api } from "@/services/api.js";

import util from "../includes/util.js";

import ListComissoes from "./ListComissoes";
import Dialog from "../components/Dialog";

export default {
  name: "ListPlanosFinalizados",
  components: { ListComissoes, Dialog },
  props: {
    itensLimit: { type: Number, default: 50 },
    propUsuario: { type: String, default: "" },
    propView: { type: String, default: "usuario" },
  },
  methods: {
    limpar() {
      this.$set(this.item, "plano", "");
      this.itens = [];
      this.planos = [];
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItens() {
      //var thisCall = this;

      this.itensUsuarioTemp = {};
      this.itensUsuario = {};
      this.itens = [];
      this.itensEventosAvulso = [];
      this.itensUsuariosDados = {};

      this.totalEventosPlano = 0;
      this.totalEventosPlanoValor = 0;
      this.totalEventosAvulso = 0;
      this.totalEventosAvulsoValor = 0;
      this.totalComissao = 0;

      var responsePlano;

      if (this.comissaoSelecionada == null) {
        responsePlano = await api.get(
          "/plano/usuarios?finalizado=true&comissao=false"
        );
      } else {
        responsePlano = await api.get(
          "/plano/usuarios?comissaoId=" + this.comissaoSelecionada
        );
      }

      api.valid(responsePlano.data, this.$router);

      if (!responsePlano.data.erro) {
        this.itens = responsePlano.data.itens;

        for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
          var item = this.itens[indiceItem];

          for (var [keyUsuario, valueUsuario] of Object.entries(
            item.finalizado.usuariosComissao
          )) {
            if (!this.itensUsuarioTemp[keyUsuario]) {
              this.itensUsuarioTemp[keyUsuario] = {
                usuario: keyUsuario,
                eventosPlano: 0,
                eventosAvulso: 0,
                comissao: 0,
              };
            }

            this.itensUsuarioTemp[keyUsuario].eventosPlano =
              this.itensUsuarioTemp[keyUsuario].eventosPlano +
              parseInt(valueUsuario);
            this.itensUsuarioTemp[keyUsuario].comissao =
              this.itensUsuarioTemp[keyUsuario].comissao +
              item.finalizado.valorUnitario *
                parseInt(valueUsuario) *
                (this.porcentagemComissao / 100);

            this.totalEventosPlano =
              this.totalEventosPlano + parseInt(valueUsuario);
            this.totalEventosPlanoValor =
              this.totalEventosPlanoValor +
              parseFloat(
                item.finalizado.valorUnitario * parseInt(valueUsuario)
              );
            this.totalComissao =
              parseFloat(this.totalComissao) +
              parseFloat(
                item.finalizado.valorUnitario *
                  parseInt(valueUsuario) *
                  (this.porcentagemComissao / 100)
              );
          }
        }
      }

      var responseEventos;

      if (this.comissaoSelecionada == null) {
        responseEventos = await api.get("/evento/usuarios?comissao=false");
      } else {
        responseEventos = await api.get(
          "/evento/usuarios?comissaoId=" + this.comissaoSelecionada
        );
      }

      api.valid(responseEventos.data, this.$router);

      if (!responseEventos.data.erro) {
        this.itensEventosAvulso = responseEventos.data.itens;

        for (
          var indiceItemEvento = 0;
          indiceItemEvento < this.itensEventosAvulso.length;
          indiceItemEvento++
        ) {
          var itemEvento = this.itensEventosAvulso[indiceItemEvento];

          if (itemEvento.excluir == false) {
            if (!this.itensUsuarioTemp[itemEvento.evento.usuarioCriacao]) {
              this.itensUsuarioTemp[itemEvento.evento.usuarioCriacao] = {
                usuario: itemEvento.evento.usuarioCriacao,
                eventosPlano: 0,
                eventosAvulso: 0,
                comissao: 0,
              };
            }

            this.itensUsuarioTemp[
              itemEvento.evento.usuarioCriacao
            ].eventosAvulso =
              this.itensUsuarioTemp[itemEvento.evento.usuarioCriacao]
                .eventosAvulso + 1;
            this.itensUsuarioTemp[itemEvento.evento.usuarioCriacao].comissao =
              this.itensUsuarioTemp[itemEvento.evento.usuarioCriacao].comissao +
              itemEvento.valor * (this.porcentagemComissao / 100);

            this.totalEventosAvulso = this.totalEventosAvulso + 1;
            this.totalEventosAvulsoValor =
              this.totalEventosAvulsoValor + itemEvento.valor;
            this.totalComissao =
              this.totalComissao +
              itemEvento.valor * (this.porcentagemComissao / 100);
          }
        }
      }

      this.itensUsuario = Object.values(this.itensUsuarioTemp).sort(
        (a, b) => b.comissao - a.comissao
      );

      if (this.retornaSite() == "7live") {
        const responseUsuario = await api.get("/usuario/apresentador");

        var itensUsuariosDadosTemp = {};

        if (!responseUsuario.data.erro) {
          responseUsuario.data.itens.forEach(function (element) {
            itensUsuariosDadosTemp[element._id] = element;
          });
        }

        this.itensUsuariosDados = itensUsuariosDadosTemp;
      }
    },
    async processarComissao() {
      if (confirm("Processar comissões ?")) {
        var apiRequest = await api.post("/comissao", {});

        if (apiRequest.data.erro) {
          alert("Erro ao processar comissao.");
        } else {
          this.comissaoSelecionada = apiRequest.data._id;
          this.carregarItens();
        }
      }
    },
    novo() {
      this.porcentagemComissao = 47;

      this.comissaoSelecionada = null;
      this.carregarItens();
      this.abaSelecionada = "planos";
    },
    editarItem(id) {
      this.$refs.editItem.carregarItem(id);
    },
    itemNovo() {
      this.$refs.editItem.novo();
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      return util.formatDateTime(data);
    },
    formatCurrency(data) {
      return util.formatCurrency(data);
    },
    formatDouble(valor) {
      return util.formatDouble(valor);
    },
    formatCurrencyNoLimit(valor) {
      return util.formatCurrencyNoLimit(valor);
    },
    selecionarComissao(itemComissao) {
      this.comissaoSelecionada = itemComissao._id;
      this.porcentagemComissao =
        new Date(itemComissao.data).getTime() > new Date("2023-08-25").getTime()
          ? 53
          : 50;

      if (
        new Date(itemComissao.data).getTime() > new Date("2025-05-31").getTime()
      ) {
        this.porcentagemComissao = 47;
      }

      this.carregarItens();
      this.$refs.dialogComissoes.fechar();
    },
    abrirDialogComissoes() {
      this.$refs.listComissoes.carregarItens();
      this.$refs.dialogComissoes.abrir();
    },
    async excluir(item) {
      if (confirm("Deseja excluir o item ?")) {
        const responsePlano = await api.post("/plano/usuario/excluir", {
          usuario: item.usuario._id,
          key: item.key,
        });
        api.valid(responsePlano.data, this.$router);

        if (!responsePlano.data.erro) {
          if (this.propView == "usuario") {
            this.carregarItensUsuario(item.usuario._id);
          } else {
            this.carregarItens();
          }
        }
      }
    },
    keyupFiltroUsuario() {
      clearTimeout(this.timerFiltroUsuario);

      var obj = this;

      this.timerFiltroUsuario = setTimeout(function () {
        obj.carregarItens();
      }, 1000);
    },
    trocarAba(aba) {
      this.abaSelecionada = aba;
    },
    exportItens() {
      var conteudo = "site\tdata\temail\tplano\tdias\tinicio\tfim\tindicacao\n";

      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        var item = this.itens[indiceItem];
        conteudo +=
          item.plano.site +
          "\t" +
          this.formatDateTime(item.dataLancamento) +
          "\t" +
          item.usuario.email +
          "\t" +
          item.plano.nome +
          "\t" +
          item.plano.duracao +
          "\t" +
          this.formatDate(item.dataInicio) +
          "\t" +
          this.formatDate(item.dataFim) +
          "\t" +
          (item.indicacao ? item.indicacao.email : "") +
          "\n";
      }

      this.$copyText(conteudo).then(
        function (e) {
          alert("Copiado com sucesso!");
          console.log(e);
        },
        function (e) {
          alert("Impossivel copiar!");
          console.log(e);
        }
      );
    },
  },
  mounted() {
    var dataAtual = new Date();
    this.filtroData.dia = 0;
    this.filtroData.mes = dataAtual.getMonth() + 1;
    this.filtroData.ano = dataAtual.getFullYear();
  },
  data: function () {
    return {
      abaSelecionada: "planos",
      //filtroTexto: "",
      filtroUsuario: "",
      filtroData: { dia: 0, mes: 0, ano: 0 },
      filtroSite: "Todos",
      //ordem:"vencimento_ASC",
      item: { plano: "" },
      itens: [],
      itensEventosAvulso: [],
      itensUsuario: {},
      itensUsuariosDados: {},
      totalEventosPlano: 0,
      totalEventosPlanoValor: 0,
      totalEventosAvulso: 0,
      totalEventosAvulsoValor: 0,
      totalComissao: 0,
      comissaoSelecionada: null,
      porcentagemComissao: 47,
      planos: [],
      itensTotal: 0,
      editItem: null,
      timerFiltroUsuario: null,
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}

.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.inputPesquisa {
  max-width: 50%;
}

.botaoNovo {
  margin-top: 6px;
}
</style>
